import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
	position: relative;
	width: 100%;
	height: 100%;

	/* IE11 fix */
	.gm-style img[src$='cluster-circle.svg'] {
		width: 32px !important;
		height: 32px !important;
	}
	.gm-style img[src$='multiple-course-marker.svg'] {
		width: 28px !important;
		height: 44px !important;
	}
	.gm-style img[src$='single-course-marker.svg'] {
		width: 28px !important;
		height: 44px !important;
	}
`;
